import { sendPost } from "./generic"

export const forgotPassword = (payload) => {
    return sendPost(`Accounts/ForgotPassword`, payload)
}

export const resetPassword = (payload) => {
    return sendPost(`Accounts/ResetPassword`, payload)
}
